<template>
    <div class="holding-tab" :class="{ 'holding-tab--single': stacked }">
        <div v-if="phus.length === 0" class="holding-tab__empty">
            <div class="holding-tab__message">
                <div class="holding-tab__title">{{ $t('phu_production.holding.empty') }}</div>
                <div class="holding-tab__action">
                    <button type="button" class="btn" @click="$emit('configure')">{{ $t('phu_production.holding.configure') }}</button>
                </div>
            </div>
        </div>

        <PhuCard
            v-for="phu in phus"
            :key="phu.id"
            class="holding-tab__phu"
            :phu="phu"
            :products="products"
            :now="now"
            :show-time="showTime"
            :external-product-id="dragProductId"
            :hover-slot-id="hoverSlotId"
            :phus="phus"
            @slot-click="$emit('slot-click', $event)"
            @save-positions="$emit('save-positions', $event)"
            @drag-product="dragProductId = $event"
            @drag-hover="hoverSlotId = $event"
            @move-across="$emit('move-across', $event)"
        />
    </div>
</template>

<script>
import PhuCard from './PhuCard.vue'

export default {
    name: 'HoldingTab',
    components: { PhuCard },
    props: {
        phus: { type: Array, required: true },
        products: { type: Object, required: true },
        now: { type: Number, required: true },
        showTime: { type: Boolean, default: false },
        fixedLayout: { type: Boolean, default: false }
    },
    data() {
        return {
            dragProductId: null,
            hoverSlotId: null
        }
    },
    computed: {
        stacked() {
            return this.fixedLayout || this.phus.length < 2 || this.$mq === 'portrait'
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.holding-tab {
    @include display-flex();
    @include flex-wrap(wrap);
    @include align-items(flex-start);
    @include align-content(flex-start);
    gap: $phu-gap;
    width: 100%;
    height: 100%;

    &__phu {
        flex: 1 1 calc((100% - #{$phu-gap}) / 2);
        max-width: calc((100% - #{$phu-gap}) / 2);
        min-width: 0;
    }

    &--single &__phu {
        flex-basis: 100%;
        max-width: 100%;
    }

    &__empty {
        @include display-flex();
        @include flex-direction(column);
        @include justify-content(center);
        flex: 1 1 100%;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    &__message {
        @include display-flex();
        @include flex-direction(column);
        @include justify-content(center);
        @include align-items(center);
        padding: 0 16px;
    }

    &__title {
        margin: 0.8rem 0 1rem;
        font-family: $text-bold;
        @include font-size(l);
        text-align: center;
    }

    &__action {
        margin-top: 40px;
    }
}
</style>
